import { useLang } from "@/lang";
import { Reveal, Eyebrow } from "@/components/Reveal";

const Stats = () => {
  const { t } = useLang();

  return (
    <section id="chiffres" data-testid="stats-section" className="bg-bei-mist py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-14 flex flex-col gap-4 sm:mb-16 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <Reveal>
              <Eyebrow>{t.stats.eyebrow}</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-5 font-display text-3xl font-extrabold tracking-tight text-bei-navy sm:text-4xl lg:text-5xl">
                {t.stats.title}
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-6 lg:grid-cols-4 lg:gap-8">
          {t.stats.items.map((s, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div
                data-testid={`stat-card-${i}`}
                className="group rounded-2xl border border-slate-200/80 bg-white p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-bei-cyan/50 hover:shadow-[0_20px_50px_rgba(11,25,44,0.08)] sm:p-9"
              >
                <p className="font-display text-4xl font-extrabold tracking-tight text-bei-brand transition-colors duration-300 group-hover:text-bei-cyan sm:text-5xl">
                  {s.value}
                </p>
                <p className="mt-4 text-sm leading-snug text-slate-600">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
